
function setAnalyticsData (key, value) {
       if (!window?.analytics_buendia) return console.error('analytics_buendia is not defined');

    window.analytics_buendia[key] = value;

}

function logError(path, eventName, expectedType, actualValue) {
    console.error(`Error at "${eventName}" event: expected "${expectedType}", got "${typeof actualValue}" on "${path}" key`);
}

function isObject(value) {
    return typeof value === 'object' && value !== null;
}

function isArray(value) {
    return Array.isArray(value);
}

function isValidDataSchema(data, schema, path = '') {

    for (const key in schema) {
        const schemaType = schema[key];
        const dataValue = data[key];
        const currentPath = path ? `${path}.${key}` : key;


        if (isObject(schemaType)) {

            if (!isObject(dataValue)) {
                logError(currentPath, data?.event, 'object', dataValue);
                return false;
            }


            if (Array.isArray(schemaType)) {

                if (!isArray(dataValue)) {
                    logError(currentPath, data?.event, 'array', dataValue);
                    return false;
                }

                for (let i = 0; i < dataValue.length; i++) {
                    const arrayPath = `${currentPath}[${i}]`;

                    if (!isValidDataSchema(dataValue[i], schemaType[0], arrayPath)) return false;
                }

                continue;
            }


            if (!isValidDataSchema(dataValue, schemaType, currentPath)) return false;

            continue;
        }


        if (typeof dataValue !== schemaType) {
            logError(currentPath, data?.event, schemaType, dataValue);
            return false;
        }
    }

    return true;
}

function getCheckoutStepNumber() {

    const url = window.location.href;
    
    const urlMap = {
        "order_information": 1,
        "review": 2,
        "payment_select": 3
    };

    for (let key in urlMap) {
        if (url.includes(key)) return urlMap[key];
    };
    
    return 0;
}

function getCurrentCheckoutData() {

    let checkoutStepNumber = getCheckoutStepNumber();

    if (!checkoutStepNumber) return;

    const eventData = {
        "1": {
            eventName: "begin_checkout",
            stepLabel: 'step_1 data'
        },
        "2": {
            eventName: "checkout_attendees",
            stepLabel: 'step_2 attendees'
        },
        "3": {
            eventName: "checkout_payment",
            stepLabel: 'step_3 confirmation'
        },
    };

    return [eventData[checkoutStepNumber].eventName, eventData[checkoutStepNumber].stepLabel];
}

function groupByTicketCategory(array) {

    if (!array?.length) return;

    const categoriesByTicket = [];

    array.forEach(item => {
        const existingCategory = categoriesByTicket.find(element => element.ticket_category === item.ticket_category);

        if (existingCategory) {
            existingCategory.quantity += item.quantity;

            Object.keys(item).forEach(key => {
                if (key !== 'ticket_category' && key !== 'quantity') {
                    existingCategory[key] = item[key];
                }
            });
            return;
        }

        categoriesByTicket.push({ ...item });
    });

    return categoriesByTicket;
}

function groupByTicketCategoryAndPerson(array) {

    if (!array?.length) return;

    const categoriesByTicket = [];

    array.forEach(item => {
        const existingCategory = categoriesByTicket.find(element =>
            element.ticket_category === item.ticket_category && element.person === item.person
        );

        if (existingCategory) {
            existingCategory.quantity += item.quantity;

            Object.keys(item).forEach(key => {
                if (key !== 'ticket_category' && key !== 'quantity' && key !== 'person') {
                    existingCategory[key] = item[key];
                }
            });
            return;
        }

        categoriesByTicket.push({ ...item });
    });

    return categoriesByTicket;
}

function findGeneralExtras(array1, array2) {
    let general_extras = [];
  
    array1.forEach(item1 => {
      const found = array2.some(item2 => item2.ticket_category === item1.ticket_category);
  
      if (!found) {
        general_extras.push(item1);
      }
    });
  
    return general_extras;
}
  


function isAdultTicket(ticketCategory) {

    if (typeof ticketCategory !== 'string') return console.error(`${ticketCategory} must be a string`);

    if (ticketCategory.trim() === '') return false;

    return ticketCategory.toLowerCase().includes('adult');

}

function calculatePrice(price, isAdult) {

    const activityType = window?.analytics_buendia?.activity_type;

    if (typeof activityType !== 'string') return console.error(`${activityType} must be a string`);
    if (typeof price !== 'number') return console.error(`${price} must be a number`);
    if (typeof isAdult !== 'boolean') return console.error(`${isAdult} must be a boolean`);

    const COMMISSION_PERCENTAGE = 0.225;
    const ADULT_COMMISSION = 2.7;

    const commissionCalculators = {
        ["actividad pago"]: () => price * COMMISSION_PERCENTAGE,
        ["free tour"]: () => isAdult ? ADULT_COMMISSION : 0,
    };

    if (!commissionCalculators[activityType]) return console.error(`${activityType} is an Invalid activity type`);

    return commissionCalculators[activityType]();
}

function triggerEvent(eventName) {
    if (typeof eventName !== "string") return console.error(`${eventName} type should be a string`)

    document.dispatchEvent(new CustomEvent(eventName))
}


function sendToDataLayer (eventData, eventKeysTypes) {
    if ( !window.dataLayer ) return console.error('dataLayer is not defined');
    if ( !isValidDataSchema(eventData, eventKeysTypes )) return;

    dataLayer.push({ecommerce: null});
    dataLayer.push({is_buendia_event: true, ...eventData});
}


export const analytics_methods = {
    setAnalyticsData,
    calculatePrice,
    isAdultTicket,
    groupByTicketCategory,
    groupByTicketCategoryAndPerson,
    findGeneralExtras,
    triggerEvent,
    sendToDataLayer,
}